import { Injectable } from '@angular/core';

import { BeehiveApiService } from '../beehive-api.service';
import { Workshop } from './workshop.model';
import { Observable, tap } from 'rxjs';
import { WorkshopType } from './workshop.util';
import { ApiQueryParams, FilterOperator } from '../api.operators';
import { Activity } from '../activity/activity.model';
import { Registration } from '../registration/registration.model';
import { patchActivity } from '../activity/activity.service';
import { patchRegistration } from '../registration/registration.util';

@Injectable({
  providedIn: 'root',
})
export class WorkshopService extends BeehiveApiService<Workshop> {
  protected entityType = Workshop;
  protected endpoint = 'workshops';

  findOneBySlug(slug: string): Observable<Workshop | null> {
    return this.findOne(
      [],
      {
        filters: {
          slug,
          type: WorkshopType.AfterSchool,
          registrationsOpenedAt: [FilterOperator.LTE, new Date()], // Need a backend endpoint for this, or the user can just set their clock to whatever date they want
        },
      },
      this.entityType,
    );
  }

  getWorkshops(params?: ApiQueryParams<Workshop>): Observable<Workshop[]> {
    const filters = {
      ...params?.filters,
      type: [FilterOperator.IN, [WorkshopType.Workshop, WorkshopType.Series]],
    };
    return this.list({ ...params, filters });
  }

  getAfterSchoolWorkshops(
    params?: ApiQueryParams<Workshop>,
  ): Observable<Workshop[]> {
    const filters = {
      ...params?.filters,
      type: [FilterOperator.EQ, WorkshopType.AfterSchool],
    };
    return this.list({ ...params, filters });
  }

  getActivities(workshop: Workshop): Observable<Activity[]> {
    return this.getMany(
      [encodeURIComponent(workshop.id), 'activities'],
      undefined,
      Activity,
    ).pipe(
      tap((activities) => {
        for (const activity of activities) {
          patchActivity(activity);
          if (activity && activity.workshop)
            activity.workshop.theme = workshop.theme;
        }
      }),
    );
  }

  getAttendants(workshop: Workshop): Observable<Registration[]> {
    return this.getMany(
      [encodeURIComponent(workshop.id), 'attendants'],
      undefined,
      Registration,
    ).pipe(tap((registrations) => registrations.forEach(patchRegistration)));
  }
}
